var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preview-calculation-page" },
    [
      _c("progressbar", { attrs: { progressbar: _vm.data.progressbar } }),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-1" }),
        _c("div", { staticClass: "col-lg-10" }, [
          _c(
            "h1",
            {
              class: {
                "mb-4": true,
                "selector-headline-smaller":
                  _vm.trans("product_selector_title").length > 80
              }
            },
            [_vm._v(_vm._s(_vm.trans("product_selector_title")))]
          )
        ]),
        _c("div", { staticClass: "col-lg-1" })
      ]),
      _c(
        "div",
        { staticClass: "row" },
        [!_vm.isLoaded ? _c("loader") : _vm._e()],
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _c(
            "div",
            { staticClass: "calculations" },
            _vm._l(_vm.data.System, function(system, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "calculation white-background box-shadow",
                  class: { recommendation: system.marked }
                },
                [
                  _c("div", { staticClass: "calculation-img" }, [
                    _c("img", {
                      attrs: { src: system.image, alt: "", title: "" },
                      on: {
                        click: function($event) {
                          return _vm.selectSystem(system.id)
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "calculation-title" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(system.name) +
                        "\n                    "
                    )
                  ]),
                  _c("div", { staticClass: "calculation-desc" }, [
                    _c("ul", [
                      _c("li", [_vm._v(_vm._s(system.expert_advice_1))]),
                      system.expert_advice_2 != null &&
                      system.expert_advice_2 != ""
                        ? _c("li", [_vm._v(_vm._s(system.expert_advice_2))])
                        : _vm._e(),
                      system.expert_advice_3 != null &&
                      system.expert_advice_3 != ""
                        ? _c("li", [_vm._v(_vm._s(system.expert_advice_3))])
                        : _vm._e()
                    ])
                  ]),
                  _vm.isShowPrices && _vm.isShowPricesSelector
                    ? _c("div", { staticClass: "calculation-price" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("currency")(system.extraData.totalPrice)
                            ) +
                            ",- " +
                            _vm._s(system.extraData.currency) +
                            "\n                    "
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "calculation-action" }, [
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _vm.isShowPrices && !_vm.isShowPricesSelector
                          ? [
                              _c("div", { staticClass: "col-lg-12 d-flex" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button type-2 ml-auto calculation-discounts",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectSystem(system.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.trans("button_details")) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ])
                            ]
                          : [
                              _c("div", { staticClass: "col-lg-12 d-flex" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button type-2 ml-auto calculation-discounts",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectSystemGoToDiscount(
                                          system.id
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.trans("button_gettingdiscount")
                                      ) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "col-lg-12 d-flex" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button type-7 ml-auto  calculation-details",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectSystem(system.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.trans("button_details")) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ])
                            ]
                      ],
                      2
                    )
                  ])
                ]
              )
            }),
            0
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "step row white-background box-shadow get-better" },
        [
          _c("div", { staticClass: "col-lg-1" }),
          _c("div", { staticClass: "col-lg-8" }, [
            _c("h3", { staticClass: "mb-4" }, [
              _vm._v(_vm._s(_vm.trans("product_selector_getbetter")))
            ]),
            _c("span", { staticClass: "get-better-text" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.trans("product_selector_getbetter_text"))
              )
            ])
          ]),
          _c("div", { staticClass: "col-lg-3" })
        ]
      ),
      _vm.trans("legal_text") != "{empty}" &&
      _vm.trans("legal_text_title") != "{empty}"
        ? _c(
            "div",
            { staticClass: "step row white-background box-shadow get-better" },
            [
              _c("div", { staticClass: "col-lg-1" }),
              _c("div", { staticClass: "col-lg-8" }, [
                _c("h3", { staticClass: "mb-4" }, [
                  _vm._v(_vm._s(_vm.trans("legal_text_title")))
                ]),
                _c("span", { staticClass: "get-better-text" }, [
                  _vm._v("\n            " + _vm._s(_vm.trans("legal_text")))
                ])
              ]),
              _c("div", { staticClass: "col-lg-3" })
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "row mb-4" }, [
        _c("div", { staticClass: "col-lg-1" }),
        _c("div", { staticClass: "col-lg-10" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-content-start align-items-center" },
            [
              _c(
                "button",
                {
                  staticClass: "button type-15 transparent",
                  attrs: { id: "backToStep2" },
                  on: {
                    click: function($event) {
                      return _vm.backToQuestions("backToQuestions")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("keyboard_backspace")
                  ]),
                  _vm._v(
                    _vm._s(_vm.trans("navigation_back")) + "\n                "
                  )
                ]
              )
            ]
          )
        ]),
        _c("div", { staticClass: "col-lg-1" })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }